export default "/img/DJ.02b96dd914ef47e089c53cb9b6958bbd.png";